import React, { useState } from 'react';

import { IconButton } from '@atlaskit/button/new';
import ChevronLeftIcon from '@atlaskit/icon/utility/migration/chevron-left';
import ChevronRightIcon from '@atlaskit/icon/utility/migration/chevron-right';
import { Flex, Grid } from '@atlaskit/primitives';

import { HTV2ActionCard } from './HTV2ActionCard';
import type { OnboardingAction } from './useOnboardingActions';

// The number of cards to show at once
const NUM_VISIBLE = 3;

function useCarousel<I>(items: I[], pageSize: number) {
	const [idx, setIdx] = useState(0);
	const hasNext = idx + pageSize < items.length;
	const hasPrevious = idx > 0;
	return {
		next: hasNext ? () => setIdx(idx + 1) : undefined,
		previous: hasPrevious ? () => setIdx(idx - 1) : undefined,
		visible: items.slice(idx, idx + pageSize),
	};
}

export function HTV2Carousel({ actions }: { actions: OnboardingAction[] }) {
	const { next, previous, visible } = useCarousel(actions, NUM_VISIBLE);
	const showControls = actions.length > NUM_VISIBLE;
	return (
		<Flex direction="column" gap="space.100">
			<Grid gap="space.200" templateColumns={`repeat(${NUM_VISIBLE}, 1fr)`}>
				{visible.map((action) => (
					<HTV2ActionCard key={action.id} action={action} />
				))}
			</Grid>

			{showControls && (
				<Flex direction="row" justifyContent="center" gap="space.100">
					<IconButton
						label="show previous item"
						icon={ChevronLeftIcon}
						onClick={previous}
						isDisabled={!previous}
					/>
					<IconButton
						label="show next item"
						icon={ChevronRightIcon}
						onClick={next}
						isDisabled={!next}
					/>
				</Flex>
			)}
		</Flex>
	);
}
